import { Sparkles } from "lucide-react";
import { TRUST_ITEMS } from "../../lib/site";

export const TrustStrip = () => (
  <section data-testid="trust-strip" className="border-y border-white/10 bg-[#070D24] py-7 overflow-hidden">
    <p className="text-center text-[11px] font-mono2 uppercase tracking-[0.3em] text-slate-500 mb-5 px-4">
      Trusted by growing brands across India
    </p>
    <div className="relative">
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#070D24] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#070D24] to-transparent z-10 pointer-events-none" />
      <div className="flex w-max animate-marquee gap-14 items-center">
        {[...TRUST_ITEMS, ...TRUST_ITEMS].map((item, i) => (
          <span
            key={i}
            data-testid={`trust-item-${i % TRUST_ITEMS.length}`}
            className="flex items-center gap-2.5 text-sm font-display font-semibold text-slate-300 whitespace-nowrap"
          >
            <Sparkles size={14} className="text-violet-400" />
            {item}
          </span>
        ))}
      </div>
    </div>
  </section>
);
